export default {
    install: function(Vue, options){
        let openedTime = Date.now();
        let show = () => {
            openedTime = Date.now();
            document.getElementsByClassName("main-preloader")[0].classList.add("active");
            document.getElementsByTagName("body")[0].classList.add('preloader-opened')
        };

        let hide = () => {
            document.getElementsByClassName("main-preloader")[0].classList.remove("active");
            document.getElementsByTagName("body")[0].classList.remove('preloader-opened')
        };

        Vue.block = () => show();
        Vue.unblock = () => hide();

        $(document).on('click', '.main-preloader', () => {
            if(Date.now() - openedTime > 3e3){
                hide();
            }
        });
    }
}


// WEBPACK FOOTER //
// ./src/plugins/preloader.plugin.js